var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeeth28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 60,
    viewBox: "0 0 59 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2777_3294)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6254 49.7599C8.83882 47.4376 4.29493 41.2447 5.05224 31.1813C5.80956 21.1179 23.2278 -3.65351 37.6168 0.991139C49.7338 4.86168 55.7923 17.2474 54.2777 32.7296C52.0057 48.9858 47.4619 52.0822 42.918 51.3081C38.3741 50.534 33.0729 49.7599 29.2863 49.7599C25.4997 49.7599 19.4412 54.4046 12.6254 49.7599Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6777 49.6747L12.6777 49.6746L12.6817 49.6773C16.0604 51.9797 19.2489 51.9808 22.0718 51.4037C23.2412 51.1646 24.3456 50.8269 25.3771 50.5114C25.593 50.4454 25.8058 50.3803 26.0152 50.3173C27.2207 49.9549 28.3228 49.6599 29.2863 49.6599C33.0824 49.6599 38.3914 50.4355 42.9348 51.2096C44.0569 51.4007 45.1737 51.3522 46.2536 50.9249C47.3334 50.4976 48.3842 49.6886 49.3692 48.3461C51.3418 45.6576 53.043 40.8405 54.1784 32.7178C55.6896 17.2641 49.6417 4.93724 37.5863 1.0864L37.586 1.0863C34.0213 -0.0643565 30.2625 0.604326 26.6093 2.42325C22.9556 4.24238 19.4153 7.20862 16.2966 10.638C13.1783 14.0669 10.4851 17.9549 8.52463 21.6127C6.56283 25.273 5.33975 28.6935 5.15196 31.1888C4.39725 41.2177 8.92538 47.3734 12.6777 49.6747Z",
    stroke: "white",
    strokeWidth: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2777_3294",
    x: 0.96875,
    y: 0.416992,
    width: 57.5391,
    height: 59.4072,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2777_3294"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2777_3294",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeeth28);
export default __webpack_public_path__ + "static/media/teeth28.84e1174c5c0d80fc3adee21f6f3422a0.svg";
export { ForwardRef as ReactComponent };